import React from 'react'
import _ from 'lodash'
import CarouselIndicator from "./common/CarouselIndicator";

const defaultClubImg = 'https://promo-offer-images.s3.amazonaws.com/../images/kickback.png'

const strHasValue = (strToCheck) => {
  return typeof strToCheck !== 'undefined' && strToCheck && strToCheck.trim().length !== 0;
}

const classForPunch = (club, punch) => {
	
	let punchClass = punch < club.currentPunches ? 'fa-check-circle' : 'fa-circle'
	if(club.cardType === 'blue-plate-special') {
		punchClass = punch < club.currentPunches ? 'fa-check-circle-o' : 'fa-circle-o'
	}
	return (
			<span className="fa-stack" key={punch}>
				<i className={`fa fa-stack-2x ${ punchClass }`}></i>
			</span>
		)
}

const customPunch = (club, punch) => {
	if (punch < club.currentPunches){
		return <div className="thumbnail" key={punch}>
              <img src={club.clubPunchedUrl} alt={club.statusText} title={club.statusText} key={punch} />
              <div className="caption is-punched">{punch + 1}</div>
            </div>;
	}else{
		return 	<div className="thumbnail" key={punch}>
              <img src={club.clubNotPunchedUrl} alt={club.statusText} title={club.statusText} key={punch} />
              <div className="caption is-notPunched">{punch + 1}</div>
            </div>;
	}
}

const ClubItem = ({ club, program, className, clubsCount, index, onSwipeLeft, onSwipeRight }) => {

  return (
    <div className={`club-card-wrapper ${className}`}>
      <div className={`club-card ${strHasValue(club.clubBgUrl) ? `club-card-custom` : club.cardType}`}>
        <div className="club-info-wrapper" style={{ background:(strHasValue(club.clubBgUrl) && program !== "kickback" ? `no-repeat url(${club.clubBgUrl}) bottom` : '') }}>
          <div className="row">
            <div className="col-xs-4 club-logo">
              <img src={`${strHasValue(club.clubImageUrl) && club.clubImageUrl !== defaultClubImg ? club.clubImageUrl : `/img/${program}_icon.png`}`} alt={club.statusText} title={club.statusText} />
            </div>
            <div className="col-xs-8 club-info">
              <h1 className="club-name">
                <strong>
                  {club.displayDescriptionAndLocation ? club.description : ''}
                </strong>
              </h1>
              <p className="lead club-location">
                <strong>
                  {club.displayDescriptionAndLocation ? club.locationName : ''}
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div className="punches-wrapper">
          <div className="punches">
            {_.times(club.numberToGet).map(i => {
              if (i < club.currentPunches) {
                if (strHasValue(club.clubPunchedUrl)) {
                  return customPunch(club, i)
                } else {
                  return classForPunch(club, i)
                }
              } else {
                if (strHasValue(club.clubNotPunchedUrl)) {
                  return customPunch(club, i)
                } else {
                  return classForPunch(club, i)
                }
              }
            })}
          </div>
        </div>
      </div>
      {className === 'active-card' ? (
        <div className="status-text">
          <CarouselIndicator active={index + 1} count={clubsCount} onSwipeLeft={onSwipeLeft} onSwipeRight={onSwipeRight} />
          <h1>{club.statusText}</h1>
        </div>
      ) : ''}
    </div>
  );
}


export default ClubItem



// WEBPACK FOOTER //
// ./src/components/ClubItem.js